<template>
  <div class="inline-flex items-center">
    <div class="rounded-md" :class="bgClasses">
      <Box class="inline-flex" padding-y="xxsmall" padding-x="xsmall">
        <Typography :color="`${color}-dark`" :variant="textVariant" class="whitespace-nowrap">
          {{ text }}
        </Typography>
      </Box>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { Box, Typography } from '@aryeo/runway'

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  textVariant: {
    type: String,
    default: 'label'
  },
  color: {
    type: String,
    default: 'success'
  }
})

const bgClasses = computed(() => {
  switch (props.color) {
    case 'warning':
      return 'bg-amber-100'
    case 'info':
      return 'bg-blue-100'
    case 'success':
      return 'bg-emerald-100'
    case 'primary':
      return 'bg-indigo-100'
    case 'danger':
      return 'bg-red-100'
    default:
      return 'bg-gray-100'
  }
})
</script>
